<template>
  <div class="panel-body">
    <div class="panel-body_head">
      <b-row>
        <b-col cols="2">
          <b-form-group class="mt-2 ml-1 mb-0">
            <b-form-select
              v-model="color"
              :options="colorOptionsSorted"
              size="sm"
            ></b-form-select>
          </b-form-group>
        </b-col>
        <b-col cols="3">
          <div class="d-flex align-items-center">
            <label class="p-0 mt-2">Recency</label>
            <b-form-group id="input-group-recency" class="year-slider">
              <Slider
                v-if="recencyRange"
                v-model="recencyLimit"
                :decimals="2"
                :min="recencyRange[0]"
                :max="recencyRange[1]"
                :type="'recency'"
              ></Slider>
            </b-form-group>
          </div>
        </b-col>
        <b-col cols="4">
          <div class="d-flex align-items-center">
            <label class="p-0 mt-2">
              Size
              <b-btn
                size="sm"
                variant="outline-secondary"
                @click="toggleSizeRange()"
                >
                <i v-if="!showRange" class="far fa-keyboard"></i>
                <i v-else class="fas fa-sliders-h"></i>
                <!--<span v-if="!showRange">Show Inputs</span>
                <span v-else>Show Range</span>-->
              </b-btn>
            </label>
            <b-form-group
              id="input-group-size"
              class="year-slider"
              v-if="!showRange"
            >
              <Slider
                v-if="sizeRange"
                v-model="sizeLimit"
                :min="parseInt(sizeRange[0])"
                :max="parseInt(sizeRange[1])"
                :type="'size'"
              ></Slider>
            </b-form-group>
            <div class="range-inputs" v-else>
              <b-form-group
                class="mb-0"
                id="fieldset-horizontal"
                label="From"
                label-for="input-horizontal"
              >
                <b-form-input
                  id="input-horizontal"
                  type="number"
                  size="sm"
                  v-model="sizeLimit[0]"
                  :value="sizeRange[0]"
                  :min="sizeRange[0]"
                  :max="sizeRange[1]"
                ></b-form-input>
              </b-form-group>
              <b-form-group
                class="mb-0"
                id="fieldset-horizontal"
                label="To"
                label-for="input-horizontal"
              >
                <b-form-input
                  id="input-horizontal"
                  type="number"
                  size="sm"
                  v-model="sizeLimit[1]"
                  :value="sizeRange[1]"
                  :min="sizeRange[0]"
                  :max="sizeRange[1]"
                ></b-form-input>
              </b-form-group>
              <small class="text-muted mt-1">
                Min value: <strong>{{ initialSizeRange[0] }}</strong> <br>
                Max value: <strong>{{ initialSizeRange[1] }}</strong> 
              </small>
            </div>
          </div>
        </b-col>
        <b-col cols="3" class="d-flex justify-content-end ml-auto">
          <b-btn
            size="sm"
            variant="outline-secondary"
            class="ml-2 text-overflow-ellipsis"
            @click="clearSorting()"
            ><i class="fa fa-eraser"></i> Clear Sorting</b-btn
          >
          <b-btn
            id="tooltip-target-1"
            size="sm"
            variant="outline-secondary"
            class="ml-2 text-overflow-ellipsis"
            @click="resetStory()"
            ><i class="fas fa-sync"></i> Reset Story</b-btn
          >
          <b-tooltip target="tooltip-target-1" triggers="hover">
            Clear all history including scroll status, sorting etc
          </b-tooltip>
          <b-btn
            size="sm"
            variant="outline-secondary"
            class="ml-2 text-overflow-ellipsis"
            @click="removeBookmarks()"
            ><i class="fa fa-trash"></i> Remove Bookmarks</b-btn
          >
        </b-col>
      </b-row>
    </div>
    <div class="panel-body_content">
      <b-row class="mt-2">
        <b-col cols="6" class="pl-4 pr-4">
          <b-form-group id="input-group-range" class="year-slider">
            <Slider
              v-if="yearRange"
              v-model="yearLimit"
              :min="yearRange[0]"
              :max="yearRange[1]"
            ></Slider>
          </b-form-group>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import { mapState, mapActions, mapMutations } from "vuex";
import Slider from "../Slider";
export default {
  name: "StorySettings",
  components: {
    Slider,
  },
  props: {
    settings: {
      type: Object,
      required: false,
      default: null,
    },
  },
  data() {
    return {
      yearRange: null,
      yearLimit: [],
      color: "recency",
      colorOptions: [],
      sizeLimit: null,
      sizeRange: null,
      recencyLimit: [-3, 3],
      recencyRange: [-3, 3],
      years: [],
      showRange: false,
      initialSizeRange: []
    };
  },
  computed: {
    ...mapState({
      documentsPerYear: (state) => state.document.documentsPerYear,
    }),
    colorOptionsSorted() {
      const generalOptions = [];
      const filterOptions = [];

      this.colorOptions.forEach((o) => {
        if (o.text.includes("filter")) {
          filterOptions.push(o);
        } else {
          generalOptions.push(o);
        }
      });

      if (filterOptions.length > 0) {
        return [
          { text: "General", value: null, disabled: true },
          ...generalOptions,
          { text: "Filter(Apply filter to enable below options)", value: null, disabled: true },
          ...filterOptions,
        ];
      }

      return generalOptions;
    }
  },
  watch: {
    color() {
      this.updateQuickSettings();
    },
    sizeLimit() {
      this.updateQuickSettings();
    },
    recencyLimit() {
      this.updateQuickSettings();
    },
    yearLimit(value) {
      if (this.years[0] !== value[0]) {
        this.years[0] = value[0];
        this.reloadTTC();
      }
      if (this.years[1] !== value[1]) {
        this.years[1] = value[1];
        this.reloadTTC();
      }
      if (this.years[2] !== value[2]) {
        this.years[2] = value[2];
        this.reloadTTC();
      }
    },
    settings(value) {
      this.color = value.color;
      this.colorOptions = value.colorOptions;
      this.sizeLimit = value.sizeRange;
      this.sizeRange = value.sizeRange;
      this.recencyLimit = value.recencyRange;
      this.recencyRange = value.recencyRange;
    },
  },
  mounted() {
    this.initSettings();
    this.initSizeSettings();
    this.initYears();
  },
  methods: {
    ...mapActions(["loadTTC"]),
    ...mapMutations(["TOGGLE_LOADING", "SAVE_LOADING_STEP"]),
    reloadTTC() {
      this.SAVE_LOADING_STEP({ loading_step: "Updating Recency" });
      this.TOGGLE_LOADING({ loading: true });
      this.loadTTC({
        state: true,
        startYear: this.years[0],
        recentYear: this.years[1],
        stopYear: this.years[2],
      }).then(() => {
        this.TOGGLE_LOADING({ loading: false });
      });
    },
    initSettings() {
      this.color = this.settings.color;
      this.colorOptions = this.settings.colorOptions;
      this.sizeLimit = this.settings.sizeRange;
      this.sizeRange = this.settings.sizeRange;
      this.recencyLimit = this.settings.recencyRange;
      this.recencyRange = this.settings.recencyRange;
    },
    initSizeSettings() {
      const temp = [];
      temp[0] = this.settings.sizeRange[0];
      temp[1] = this.settings.sizeRange[1];
      this.initialSizeRange = temp;
    },
    initYears() {
      if (this.documentsPerYear.length > 0) {
        const yearMin = parseInt(_.minBy(this.documentsPerYear, "year").year);
        const yearMax = parseInt(_.maxBy(this.documentsPerYear, "year").year);
        this.yearRange = [yearMin, yearMax];
        this.yearLimit = [yearMin, yearMax - 2, yearMax];
        this.years = this.yearLimit;
      }
    },
    updateQuickSettings() {
      this.$emit("updateSettings", {
        color: this.color,
        sizeLimit: this.sizeLimit,
        recencyLimit: this.recencyLimit,
      });
    },
    removeBookmarks() {
      this.$emit("removeBookmarks");
    },
    clearSorting() {
      this.$emit("clearSorting");
    },
    resetStory() {
      this.$emit("resetStory");
    },
    toggleSizeRange() {
      this.showRange = !this.showRange;
    },
  },
};
</script>
